module.exports = __webpack_public_path__ + "static/img/3.f5d03ed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/1/sp/3.png
// module id = v3cl
// module chunks = 0